import React from 'react';

import useVPVOnActivePanel from 'shared-utils/src/useVPVOnActivePanel';
import useDialogAccessibilityFeatures from 'shared-utils/src/useDialogAccessibilityFeatures'; 

import PTypes from '../ContentPTypesQB';

const LicenseTypeGroups = (props) => {
  const {
    queryBuilderProps: {
      isActivePanel,
      panelId,
      headerTitleId,
      closeModal,
      paPage,
    } = {},
  } = props;

  useDialogAccessibilityFeatures(isActivePanel ? {
    elementId: panelId,
    isOpen: isActivePanel,
    closefn: () => closeModal(),
    customFocusableElements: [`#${headerTitleId}`],
  } : {});

  useVPVOnActivePanel({
    isActivePanel,
    paPageDimensions: {
      page: paPage,
      cust_event_name: paPage,
      cust_page_type: undefined,
      cust_prev_page: window.paDatalayer?.page || '',
    },
  });   

  return (
    <PTypes {...props} content="licenseTypeGroups" />
  );
};

export default LicenseTypeGroups;
